// extracted by mini-css-extract-plugin
module.exports = {"Token":"_1FbdBRAZ8I9hPEldIrhvXC","Button":"_24UQuEwfZX6W0wREXwJ2kE"};